import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Trash2 } from "lucide-react";
import { OrderButtons } from "./OrderButtons";

export const DividerRow = ({ fd, divider: d, isFirst, isLast }) => {
  const dirty = fd.isDirty("divider", d.key);
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-12 gap-2 items-center p-2 rounded border ${dirty ? "border-amber-300 bg-amber-50/40" : "border-slate-200 bg-slate-50"}`}
         data-testid={`fd-divider-row-${d.key}`}>
      <div className="sm:col-span-3">
        <code className="text-xs text-slate-500">divider</code>
        <div className="text-[11px] text-slate-400 truncate">{d.key}</div>
      </div>
      <div className="sm:col-span-5">
        <Input value={d.label}
               onChange={(e) => fd.setDraftValue("divider", d.key, "label", e.target.value)}
               placeholder="Section heading text…"
               className="h-9 font-bold uppercase tracking-wider text-xs"
               data-testid={`fd-divider-label-${d.key}`} />
      </div>
      <div className="sm:col-span-2"></div>
      <OrderButtons onMove={(dir) => fd.moveItem("divider", d.key, dir)}
                    isFirst={isFirst} isLast={isLast} kind="divider" itemKey={d.key} />
      <div className="sm:col-span-1 text-right">
        <Button size="sm" variant="ghost" onClick={() => fd.deleteDivider(d)}
                title="Delete divider" data-testid={`fd-divider-delete-${d.key}`}>
          <Trash2 className="h-3 w-3 text-rose-600" />
        </Button>
      </div>
    </div>
  );
};
